module.exports = __webpack_public_path__ + "static/media/avatar-icon.24e53523.svg";